import { makeStyles } from '@material-ui/core/styles';

export const useSearchFilterStyles = makeStyles((theme) => ({
  mobileFilter: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  hideOnMobile: {
    display: 'none',
  },
  searchFiltersContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
}));
